export enum NOTA_DEBITO_TYPES {
  ND_SET_VIEW = 'ND_SET_VIEW',
  ND_SET_FORM_CLIENTE = 'ND_SET_FORM_CLIENTE',
  ND_HANDLE_ERRORS_CLIENTE = 'ND_HANDLE_ERRORS_CLIENTE',
  ND_SET_FORM_PRODUCTO = 'ND_SET_FORM_PRODUCTO',
  ND_HANDLE_ERRORS_PRODUCTO = 'ND_HANDLE_ERRORS_PRODUCTO',
  ND_SET_PRODUCTOS = 'ND_SET_PRODUCTOS',
  ND_SET_PRODUCTO_EDIT = 'ND_SET_PRODUCTO_EDIT',
  ND_SET_PRODUCTO_INDEX = 'ND_SET_PRODUCTO_INDEX',

  ND_ACTIVE_MODAL_EDITAR_PRODUCTO = 'ND_ACTIVE_MODAL_EDITAR_PRODUCTO',
  ND_ACTIVE_MODAL_ELIMINAR_PRODUCTO = 'ND_ACTIVE_MODAL_ELIMINAR_PRODUCTO',
  ND_ACTIVE_MODAL_QUITAR_TODO = 'ND_ACTIVE_MODAL_QUITAR_TODO',
  ND_ACTIVE_MODAL_EMITIR = 'ND_ACTIVE_MODAL_EMITIR',
  ND_ACTIVE_MODAL_EMITIDO = 'ND_ACTIVE_MODAL_EMITIDO',
  ND_ACTIVE_MODAL_MAS_OPCIONES = 'ND_ACTIVE_MODAL_MAS_OPCIONES',
  ND_ACTIVE_MODAL_ENVIAR_CORREO = 'ND_ACTIVE_MODAL_ENVIAR_CORREO',
  ND_ACTIVE_MODAL_IMPRIMIR = 'ND_ACTIVE_MODAL_IMPRIMIR',
  ND_ACTIVE_MODAL_ANULAR = 'ND_ACTIVE_MODAL_ANULAR',
  ND_ACTIVE_MODAL_ANULADO = 'ND_ACTIVE_MODAL_ANULADO',
  
  ND_SET_TOTAL_ORIGINAL = 'ND_SET_TOTAL_ORIGINAL',
  ND_SET_PRODUCTOS_ORIGINAL= 'ND_SET_PRODUCTOS_ORIGINAL',

  ND_SET_QR_CODE = 'ND_SET_QR_CODE',
  ND_SET_RESPONSE_EMITIR = 'ND_SET_RESPONSE_EMITIR',

  ND_SET_CALCULOS_PRODUCTO = 'ND_SET_CALCULOS_PRODUCTO',
  ND_SET_CALCULOS_GENERALES = 'ND_SET_CALCULOS_GENERALES',

  ND_RESTART_FORM_PRODUCTO = 'ND_RESTART_FORM_PRODUCTO',
  ND_RESTART_ALL = 'ND_RESTART_ALL',
  ND_SET_CLIENTE_ENDONTRADO = 'ND_SET_CLIENTE_ENDONTRADO',
  ND_ACTIVE_MODAL_CLIENTE_ENDONTRADO = 'ND_ACTIVE_MODAL_CLIENTE_ENDONTRADO',
  ND_FORMOBSERVACIONES_HANDLE_CHANGE = 'ND_FORMOBSERVACIONES_HANDLE_CHANGE',
}
